<template>
	<v-card dense>
		<v-col>
		<!-- <s-toolbar
			dark
			color="#BDBDBD"
			close
			@close="closeDialogAdmin()"
		></s-toolbar> -->

		<v-row>
			<v-col>
				<s-crud
					:config="config"
					:filter="filter"
					close
					:title="'Pallets en ' + (chamberSelected.TypeChamberTunnel == 1 ? 'Cámara' : 'Tunel') "
					@close="closeDialogAdmin()"
					ref="listPallet"
					searchInput
				>
					<template v-slot:filter>
						<v-container>
							<v-row>
								<v-col>
									<s-select-customer 
										clearable 
										label="Cliente" 
										v-model="filter.UwoCustomerID"
									></s-select-customer>
								</v-col>
								<v-col>
								 <s-text
									label="N° de PrePacking"			
									number						
									v-model="filter.PppPrePackingNumber"
									></s-text>
								</v-col>
							</v-row>
						</v-container>
					</template>
					<template v-slot:PltID="{ row }">
						 {{row.PltID + "-" + row.PltCorrelative}}
					</template>
					<template v-slot:CocChange="{ row }">
						<v-btn
							color="primary"
							x-small
							rounded
							@click="clickCocChange(row)"
							>
							<i class="fas fa-edit"></i>
							</v-btn>
					</template>
					<template v-slot:CocDateBeginEdit="{ row }">
						<v-btn
							color="primary"
							x-small
							rounded
							@click="clickCocDateBegin(row)"
						>
						<i class="far fa-calendar-times"></i>
						<!--<i class="far fa-calendar-alt"></i>
						<i class="far fa-clock"></i>-->
							
						</v-btn>
					</template>
					<template v-slot:Pulple="{ row }">
						<v-btn
							color="error"
							x-small
							rounded
							@click="clickPulple(row)"
						>
						<i class="fas fa-temperature-low"></i>
						<!--<i class="far fa-calendar-alt"></i>
						<i class="far fa-clock"></i>-->
							
						</v-btn>
					</template>
				</s-crud>
			</v-col>
		</v-row>
		</v-col>
		<v-dialog 
			v-if="dialogChange"
			v-model="dialogChange"
			persistent
			hide-overlay
			width="60%">
			<v-card>
				<supply-chamber-change :chaID="this.chamberSelected.ChaID" :PltID="pltID" @EndProcess="endProcessChange($event)"></supply-chamber-change>
			</v-card>
		</v-dialog>

		<v-dialog 
			v-if="dialogTimeChange"
			v-model="dialogTimeChange"
			persistent
			hide-overlay
			width="60%">
			<v-card>
				<registration-time-change :CocDateBeginR="cocDateBegin" :CocID="cocID"  @EndProcess="endProcessChange($event)" ></registration-time-change>
			</v-card>
		</v-dialog>
		<v-dialog 
			v-if="dialogPulpleChange"
			v-model="dialogPulpleChange"
			persistent 
			height="700px"
			width="40%">
			<v-card>
				<cooling-chamber-admi-pulple :pallets="itemsPulple" :item="chamberSelected" @close="closePuple()"></cooling-chamber-admi-pulple>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import sSelectCustomer from "@/components/Sale/SselectClientSap.vue";

	import _sPrfCoolingChamber from "@/services/FreshProduction/PrfCoolingChamberService";
	import SupplyChamberChange from "./SupplyChamberChange.vue";
	import RegistrationTimeChange from "./RegistrationTimeChange.vue";
	import CoolingChamberAdmiPulple from "./CoolingChamberAdmiPulple.vue";

	export default {
		components: {
			sSelectCustomer,
			SupplyChamberChange,
			RegistrationTimeChange,
			CoolingChamberAdmiPulple
		},

		props: {
			chamberSelected: null
		},

		data() {
			return {
				config: {
					model: {
						PltID: "ID",
						CocChange: "",
						CocDateBegin: "datetime",
						CocDateBeginEdit: "",
						Pulple: "",
						PltWeightBoxe: "decimal",
						TotalWeightBoxes: "decimal",
						UwoMaterialListNumberBoxes: "int",
						PppPrePackingNumber: "int",
					},
					service: _sPrfCoolingChamber,
					headers: [
						{text:"Pallet", value: "PltID"},
						{text:"Horas Dentro", value: "TimeInside"},
						{text:"N° de Pre Packing", value: "PppPrePackingNumber"},
						{text:"Fecha de Ingreso", value: "CocDateBegin"},
						{text:"Peso por Caja", value: "PltWeightBoxe"},
						{text:"Peso Standar del Pallet", value: "PltWeightStandar"},
						{text:"Cantidad de Cajas", value: "UwoMaterialListNumberBoxes"},
						{text:"Cliente", value: "CardName"},
						{text:"Calibre", value: "TypeCaliberName"},
						{text:"Presentación", value: "PresentationName"},
						{text:"Cultivo", value: "TypeCultiveName"},
						{text:"Tipo Cultivo", value: "TypeCropName"},
						{text:"Variedad", value: "VarietyName"},
						{text:"Temperatura Pulpa (°C)", value: "CoeTempEnvir01"},
						{text:"Fila", value: "ChrDescription"},
						{text:"Carril", value: "ChpPosition"},
						{text:"Columna", value: "ChcDescription"},
						{text:"Cambiar", value: "CocChange"},
						{text:"Editar Hora y Fecha", value: "CocDateBeginEdit"},
						{text:"Pulpa", value: "Pulple"},
					]
				},
				filter:{
					ChaID: this.chamberSelected.ChaID,
					PppPrePackingNumber:null,
				},				
				cocID: 0,			
				cocDateBegin: "",
				dialogChange: false,
				dialogTimeChange: false,
				dialogPulpleChange: false,
				itemsPulple: [],
			}
		},

		methods: {
			endProcessChange( coc ){
				this.dialogChange = false;
				this.dialogTimeChange = false;
				if (coc != null) {
					this.$refs.listPallet.refresh();
				}
			},
			closeDialogAdmin() {
				this.$emit("closeDialogAdmin")
			},
			clickCocChange( item ){
				console.log(item);
				this.pltID = item.PltID;
				this.dialogChange = true;
			},

			clickCocDateBegin( item ){
				console.log(item);				
				this.cocID = item.CocID;	
				this.cocDateBegin = this.$moment(new Date(item.CocDateBegin)).format("DD-MM-YYYY HH:mm:SS");
				this.dialogTimeChange = true;
			},
			clickPulple( item ){
				this.itemsPulple = [];
				this.itemsPulple.push( item );
				this.dialogPulpleChange = true;
			},
			closePuple(){
				this.dialogPulpleChange = false;
				this.$refs.listPallet.refresh();
			},
		},

		created () {
			console.log('chamberSelected ', this.chamberSelected);
		},
	}
</script>

<style scoped>

</style>